import { Permission } from "@edgetier/watchtower-types";

export const PermissionDescription: Record<number, string> = {
    [Permission.ViewAgent]: "Analyse agents' performance on the Agent and Agents screens.",
    [Permission.ViewExplore]: "Access to the Explore screen.",
    [Permission.ViewAnomalies]: "View previous anomalies detected by the system.",
    [Permission.ManageUsers]: "Invite, edit, or delete WatchTower users.",
    [Permission.ManageWritingIssues]: "Create, update, or remove spelling exemptions.",
    [Permission.ManageInteractionTags]: "Add, edit, or remove tags from any interaction.",
    [Permission.ManagePhraseTriggers]:
        "Create, edit, and delete rules to apply tags to messages matching specific phrases.",
    [Permission.ViewLive]: "View real-time agents, queues, and interactions.",
    [Permission.ViewCustomReports]: "View custom metabase reports.",
    [Permission.ManageAgentTags]: "Assign or remove agents from groups.",
    [Permission.AddOrRemoveEmotions]: "Add or remove emotions from messages.",
    [Permission.DownloadInteractions]: "Export/download interactions as a CSV.",
    [Permission.ManageTeams]: "Create, update, or remove user teams used for data segmentation.",
    [Permission.ManageRoles]:
        "View, create and update role permissions. Disabled users can't access the permissions table.",
    [Permission.ManageAllReviews]:
        "Users can create, update, or remove reviews and scorecards for any agent in the system, and view all reviews in their organisation.",
    [Permission.ManageOwnReviews]:
        "Users can create reviews and manage their own reviews. They cannot access or manage reviews completed by other users.",
    [Permission.ViewReceivedReviews]:
        "Agents can gain view-only access to their own reviews. They can see their own QA reviews but cannot modify or delete them.",
    [Permission.ViewAgentDetails]:
        "Agent names and email addresses are displayed throughout the system. When turned off, agent names and email addresses will be replaced with ‘Agent Hidden’",
    [Permission.ManageScorecards]: "Create, update, or remove scorecards that will be used for agent reviews.",
    [Permission.ViewCustomerInsights]:
        "Users can view the Customers section, including aggregated insights, AI customer summaries and customer emotions.",
    [Permission.ViewAllReviews]: "Users can view all reviews in the organisation, but cannot create or edit them.",
    [Permission.ViewOwnAgentActivity]: "Agents can log in and view only their own activity and interactions.",
    [Permission.ExportInteractionData]: "Export/download interactions as PDF files.",
    [Permission.TagPastInteractions]: "Apply phrase tags to past interactions retroactively.",
    [Permission.ManageAiTags]: "Create and update AI tag definitions and prompts.",
    [Permission.UseAskSpotlight]: "Access the Ask Spotlight feature.",
    [Permission.PlayAllCallRecordings]: "User can listen to call recordings for any interaction they can access.",
    [Permission.PlayOwnCallRecordings]: "User can listen to call recordings only for interactions they handled.",
    [Permission.ManageAnomalyModels]: "Create and edit your organisation's anomaly model settings in Sonar.",
    [Permission.ManageAiRules]: "Manage 'Ask Spotlight' Company Context",
    [Permission.ViewAskSpotlightUsage]: "View Ask Spotlight usage analytics.",
};

/**
 * Every permission the front end knows about. Used where the full set of a user's permissions is needed, rather than
 * a check against one specific permission.
 */
export const ALL_PERMISSIONS = Object.values(Permission).filter(
    (value): value is Permission => typeof value === "number"
);

export const HOME_PERMISSIONS = [
    Permission.ViewAnomalies,
    Permission.ViewExplore,
    Permission.ViewLive,
    Permission.ViewCustomerInsights,
];
